/** @format */

import { CiStar } from "react-icons/ci";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";

const Ratings = ({ ratings }) => {
  return (
    <>
      {ratings >= 1 ? (
        <span className='text-[#edbb0e]'>
          <FaStar />
        </span>
      ) : ratings >= 0.5 ? (
        <span className='text-[#edbb0e]'>
          <FaStarHalfAlt />
        </span>
      ) : (
        <span>
          <CiStar />
        </span>
      )}
      {ratings >= 2 ? (
        <span className='text-[#edbb0e]'>
          <FaStar />
        </span>
      ) : ratings >= 1.5 ? (
        <span className='text-[#edbb0e]'>
          <FaStarHalfAlt />
        </span>
      ) : (
        <span>
          <CiStar />
        </span>
      )}
      {ratings >= 3 ? (
        <span className='text-[#edbb0e]'>
          <FaStar />
        </span>
      ) : ratings >= 2.5 ? (
        <span className='text-[#edbb0e]'>
          <FaStarHalfAlt />
        </span>
      ) : (
        <span>
          <CiStar />
        </span>
      )}
      {ratings >= 4 ? (
        <span className='text-[#edbb0e]'>
          <FaStar />
        </span>
      ) : ratings >= 3.5 ? (
        <span className='text-[#edbb0e]'>
          <FaStarHalfAlt />
        </span>
      ) : (
        <span>
          <CiStar />
        </span>
      )}
      {ratings >= 5 ? (
        <span className='text-[#edbb0e]'>
          <FaStar />
        </span>
      ) : ratings >= 4.5 ? (
        <span className='text-[#edbb0e]'>
          <FaStarHalfAlt />
        </span>
      ) : (
        <span>
          <CiStar />
        </span>
      )}
    </>
  );
};

export default Ratings;
